import { useRouter } from 'next/router';

/**
 * 할인 안내가 방해가 되는 화면들. 결제·견적 진행 중에는 배너도 모달도 띄우지 않는다.
 * (Figma 체크아웃 29139:3833 / 견적 29111:1758·29113:6288 에는 상단 배너가 없다.)
 */
export const TRIAL_END_DISCOUNT_SUPPRESSED_PATH_PREFIXES = [
  '/lti',
  '/checkout',
  '/pricing/quote',
  '/verification-phone',
];

export const useIsTrialEndDiscountSuppressed = () => {
  const { pathname } = useRouter();

  return TRIAL_END_DISCOUNT_SUPPRESSED_PATH_PREFIXES.some(path =>
    pathname.startsWith(path),
  );
};
